import { createFileRoute, notFound } from "@tanstack/react-router";
import { getGeoArticle } from "@/lib/geo-data";
import { ArticlePage } from "@/components/article-page";
import { articleHead } from "@/lib/article-seo";
import { NotFoundPage } from "@/components/not-found-page";
import type { Article } from "@/lib/content-blocks";

export const Route = createFileRoute("/geo/$slug")({
  head: ({ params }) =>
    articleHead({
      item: getGeoArticle(params.slug),
      slug: params.slug,
      base: "/geo",
      areaName: "Generative Engine Optimization (GEO)",
      noun: "Guide",
      schema: "article",
    }),
  loader: ({ params }) => {
    const item = getGeoArticle(params.slug);
    if (!item) throw notFound();
    return { item };
  },
  component: GeoArticleRoute,
  notFoundComponent: () => <NotFoundPage />,
  errorComponent: ({ error }) => (
    <div className="py-12">
      <h1 className="text-2xl font-semibold mb-2">Something went wrong</h1>
      <p className="text-muted-foreground mb-6">{error.message}</p>
    </div>
  ),
});

function GeoArticleRoute() {
  const { item } = Route.useLoaderData() as { item: Article };
  return <ArticlePage item={item} />;
}
